const items = {
  "channel.title": "channel",
  "channel.type": "type",
  "channel.name": "name",
  "channel.create.message.noname": "请输入版本名称",
  "channel.type.all.title": "all",
  "channel.type.translation.label": "translation",
  "channel.type.nissaya.label": "Nissaya",
  "channel.type.commentary.label": "commentary",
  "channel.type.original.label": "original",
  "channel.type.message.required": "请输入版本类型",
  "channel.lang": "language",
  "channel.fields.lang.label": "语言",
  "channel.fields.type.label": "类型",
  "channel.fields.name.label": "名称",
  "channel.type.similar.label": "Similar",
};

export default items;
